import { render, staticRenderFns } from "./WYSIWYGTypeEditor.vue?vue&type=template&id=0835f927&"
import script from "./WYSIWYGTypeEditor.vue?vue&type=script&lang=ts&"
export * from "./WYSIWYGTypeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./WYSIWYGTypeEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports